import { Command } from 'cmdk';
import styled from 'styled-components';
import { COLORS } from 'src/styles/colours';
import { media } from 'src/styles/Breakpoints';
import { FONT_SIZE } from '../../constants/fontSizes';
import { Z_INDEX } from '../../constants/zIndexes';

export const CommandMenuDialog = styled(Command.Dialog)`
  background: ${COLORS.WHITE};
  backdrop-filter: blur(20px);
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: ${COLORS.GRAY2};
  width: 600px;
  max-width: calc(100vw - 32px);
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  font-family: Montserrat;
  position: absolute;
  top: 0;
  z-index: ${Z_INDEX.COMMAND_MENU};

  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  overflow: hidden;

  @media screen and (${media.maxMobile}) {
    left: 0;
    right: 0;
    width: auto;
    max-width: none;
    border: none;
    border-radius: 0;
    -webkit-transform: none;
    transform: none;
  }

  & > [cmdk-list] {
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 16px;

    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
`;

export const CommandMenuSearchInput = styled(Command.Input)`
  width: 100%;
  padding: 16px;
  font-size: ${FONT_SIZE.MEDIUM};
  border: none;
  background: transparent;
  outline: none;
  color: ${COLORS.GRAY2};
  border-bottom: 1px solid ${COLORS.GRAY3};

  &::placeholder {
    color: ${COLORS.GRAY2};
  }
`;

export const CommandMenuSectionTitle = styled(Command.Group)`
  font-size: ${FONT_SIZE.NORMAL};
  font-weight: 600;
  color: ${COLORS.GRAY2};
  text-transform: uppercase;
  margin-top: 10px;
`;

export const CommandMenuItem = styled(Command.Item)`
  display: flex;
  align-items: center;
  padding: 10px 16px;
  gap: 12px;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.1s ease-in-out;
  user-select: none;

  &[data-selected='true'] {
    background-color: ${COLORS.GRAY3};
  }
`;

export const CommandMenuListItemText = styled.div`
  flex-grow: 1;
  font-size: ${FONT_SIZE.MEDIUM};
  font-weight: 500;
`;

export const CommandMenuListItemAdditionalInfo = styled.span`
  font-size: ${FONT_SIZE.NORMAL};
  font-weight: 400;
  color: ${COLORS.GRAY};
`;

export const CommandMenuFooter = styled.footer`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-top: 1px solid ${COLORS.GRAY3};
  gap: 12px;
  color: ${COLORS.GRAY2};
  font-size: ${FONT_SIZE.NORMAL};
  user-select: none;
`;

export const CommandMenuFooterText = styled.span`
  font-size: ${FONT_SIZE.NORMAL};
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const CommandMenuKeyboardKey = styled.span`
  background: ${COLORS.GRAY3};
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 0 6px;
  font-size: ${FONT_SIZE.NORMAL};
  font-family: monospace;
`;

export const CommandNoResults = styled(Command.Empty)`
  font-size: ${FONT_SIZE.NORMAL};
  margin: 16px 0;
  font-weight: 500;
  color: ${COLORS.GRAY};
`;

export const CommandMenuLoading = styled(Command.Loading)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: ${FONT_SIZE.NORMAL};
  margin: 16px 0;
  font-weight: 500;
  color: ${COLORS.GRAY};

  & > div {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;
